import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-filter-list",
    templateUrl: "./filter-list.component.html",
    styleUrls: ["./filter-list.component.scss"],
})
export class FilterListComponent implements OnInit {
    ngOnInit(): void {}
}
